import {
  makeSelectedEvent,
  selectEventCurrency,
  selectSelectedBundles,
  selectSelectedTickets,
  selectVoucherData,
} from 'app/pages/TicketSalePage/slice/selectors';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectMerchantTaxName } from 'store/vendorSlice/selectors';
import { formatMoney } from 'utils/formatMoney';
import { getCartTotal } from 'utils/getItemsTotal';
import { buildPriceToShow } from 'utils/tickets';
import CartBundle, { getCartBundleKey } from '../CartTotal/CartBundle';
import CartItem from '../CartTotal/CartItem';
import CartTicket, { getCartTicketKey } from '../CartTotal/CartTicket';

const TicketSalePageTotal: React.FC<{}> = memo(() => {
  const { t } = useTranslation();
  const selectedEvent = useSelector(makeSelectedEvent);
  const eventCurrency = useSelector(selectEventCurrency);
  const selectedTickets = useSelector(selectSelectedTickets);
  const selectedBundles = useSelector(selectSelectedBundles);

  const voucher = useSelector(selectVoucherData);
  const { voucherData, voucherApplicableTickets } = voucher;
  const merchantTaxName = useSelector(selectMerchantTaxName);

  const { cartTotal, taxTotal, feeTotal } = getCartTotal(
    [...selectedTickets, ...selectedBundles],
    selectedEvent,
    voucher,
  );

  const displayTotalSection =
    selectedTickets.length > 0 || selectedBundles.length > 0;

  return (
    <div
      className={`${
        !displayTotalSection ? 'hidden' : ''
      } bg-neutral-10 border-b border-neutral-40 p-[12px] sm:px-[24px] sm:py-[16px]`}
    >
      {selectedBundles.map(bundle => (
        <CartBundle
          key={getCartBundleKey(bundle)}
          bundle={bundle}
          event={selectedEvent}
        />
      ))}
      {selectedTickets.map(ticket => (
        <CartTicket
          key={getCartTicketKey(ticket)}
          ticket={ticket}
          event={selectedEvent}
          voucher={voucherData}
          voucherApplicableTickets={voucherApplicableTickets}
        />
      ))}
      {taxTotal > 0 ? (
        <CartItem
          name={merchantTaxName}
          price={buildPriceToShow(taxTotal, eventCurrency)}
          size={4}
        />
      ) : null}
      {feeTotal > 0 ? (
        <CartItem
          name={t('ticketSale.fee')}
          price={buildPriceToShow(feeTotal, eventCurrency)}
          size={4}
        />
      ) : null}

      <div className="flex justify-between pt-[16px]">
        <p className="text-[24px] font-semibold uppercase">
          {t('ticketSale.total')}
        </p>
        <p className="text-[24px] font-semibold">
          {buildPriceToShow(
            cartTotal + taxTotal + feeTotal,
            eventCurrency,
            formatMoney(0, eventCurrency),
          )}
        </p>
      </div>
    </div>
  );
});

export default TicketSalePageTotal;
